import { useRef, useEffect, useCallback, PropsWithChildren, FC, useState } from 'react'
import { Spin } from 'antd'
import { CaretUpOutlined } from '@ant-design/icons'
import { DualAxes } from '@antv/g2plot';
import Card from '@/pages/Tbqy/components/components/Card'
import CardContainer from '@/pages/Bmjy/components/components/CardContainer'
import styles from './style.module.less'

const tabsOptions = [
  {
    label: '按公司',
    value: 'ags',
    api: null
  }, 
  {
    label: '按院', 
    value: 'ay',
    api: null
  }, 
  {
    label: '按所', 
    value: 'as',
    api: null
  }
]

type PropType = FC<PropsWithChildren<{
  updateTime: string
}>>

const Component: PropType = ({updateTime}) => {
  const [loading, setLoading] = useState(false)
  const globalRef = useRef({
    params: {
      tab: '',
      depart: ''
    },
    column: null as DualAxes,
    loadTime: updateTime
  })

  const getData = useCallback(async () => {
    
  }, [])

  // 变更类型
  const handleTabChange = useCallback((value) => {
    globalRef.current.params = value
    getData()
  }, [getData])

  return (
    <Spin spinning={loading}>
      <CardContainer
          hasExport={false}
        >
          <div className='flex mt-30 mlr-10'>
            <div className={`flex ${styles['blue-item']} flex-1`}>
              <div className={`${styles['item-tag']} font-32`}>总</div>
              <div className='ml-16 flex-1'>
                <div className='text-999'>本年委托单总数</div>
                <div>
                  <span className={`${styles['item-value']} font-28 font-700`}>2,616</span>
                  <span className='font-12 ml-6'>份</span>
                </div>
              </div>
              <div className='ml-16 flex-1'>
                <div className='text-999'>上年委托单总数</div>
                <div>
                  <span className={`${styles['item-value']} font-28 font-700`}>--</span>
                  <span className='font-12 ml-6'>份</span>
                </div>
              </div>
              <div className='ml-16 flex-1'>
                <div className='text-999'>同比</div>
                <div>
                  <span className={`${styles['item-value']} font-28 font-700`}><CaretUpOutlined />13.6%</span>
                </div>
              </div>
            </div>
            <div className={`flex ${styles['green-item']} flex-1`}>
              <div className={`${styles['item-tag']} font-22`}>实验</div>
              <div className='ml-16 flex-1'>
                <div className='text-999'>实验室委托单数</div>
                <div>
                  <span className={`${styles['item-value']} font-28 font-700`}>86</span>
                  <span className='font-12 ml-6'>份</span>
                </div>
              </div>
              <div className='ml-16 flex-1'>
                <div className='text-999'>线上委托</div>
                <div>
                  <span className={`${styles['item-value']} font-28 font-700`}>46</span>
                  <span className='font-12 ml-6'>份</span>
                </div>
              </div>
              <div className='ml-16 flex-1'>
                <div className='text-999'>线下委托</div>
                <div>
                <span className={`${styles['item-value']} font-28 font-700`}>40</span>
                <span className='font-12 ml-6'>份</span>
                </div>
              </div>
            </div>
            <div className={`flex ${styles['qing-item']} flex-1`}>
              <div className={`${styles['item-tag']} font-22`}>现场</div>
              <div className='ml-16 flex-1'>
                <div className='text-999'>现场委托单数</div>
                <div>
                  <span className={`${styles['item-value']} font-28 font-700`}>86</span>
                  <span className='font-12 ml-6'>份</span>
                </div>
              </div>
              <div className='ml-16 flex-1'>
                <div className='text-999'>线上委托</div>
                <div>
                  <span className={`${styles['item-value']} font-28 font-700`}>46</span>
                  <span className='font-12 ml-6'>份</span>
                </div>
              </div>
              <div className='ml-16 flex-1'>
                <div className='text-999'>线下委托</div>
                <div>
                <span className={`${styles['item-value']} font-28 font-700`}>40</span>
                <span className='font-12 ml-6'>份</span>
                </div>
              </div>
            </div>
            <div className={`flex ${styles['orange-item']}`}>
              <div className={`${styles['item-tag']} font-22`}>其他</div>
              <div className='ml-16 flex-1'>
                <div className='text-999'>其他委托单数</div>
                <div>
                  <span className={`${styles['item-value']} font-28 font-700`}>16</span>
                  <span className='font-12 ml-6'>份</span>
                </div>
              </div>
            </div>
          </div>
        </CardContainer>
    </Spin>
  )
}

export default Component
